import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from '../components/user/Header';
import Footer from '../components/user/Footer';
// import Breadcrumbs from '../components/user/Breadcrumbs'; // Will hide for now and enable it later

function UserLayout({ children }) {
  const location = useLocation();
  const isDashboard = location.pathname === '/user/dashboard';
  const isFeedPage = location.pathname === '/user/feed' || location.pathname === '/user/my-feed';
  const isCourseWatch = location.pathname.includes('/user/courses/WatchCourse/');
  const [isMobile, setIsMobile] = useState(typeof window !== 'undefined' ? window.innerWidth < 768 : false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (isFeedPage) {
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = '';
      };
    }
  }, [isFeedPage]);

  return (
    <div className={`flex flex-col ${isFeedPage ? 'h-screen overflow-hidden' : 'min-h-screen'}`} style={{ backgroundColor: 'colors.background' }}>
      {/* Top navigation bar */}
      <Header />

      {/* Main content area - extra bottom padding on mobile for bottom tab bar */}
      <main
        className={`flex-1 px-4 pt-2 pb-3 sm:px-6 sm:pt-3 lg:px-8 lg:pt-3 lg:pb-4 ${isFeedPage ? 'overflow-hidden' : ''}`}
        style={isMobile ? { paddingBottom: 'calc(90px + env(safe-area-inset-bottom, 0px))' } : {}}
      >
        <div className={`mx-auto w-full ${isFeedPage ? 'h-full' : ''}`} style={{ maxWidth: 'var(--layout-max-width)' }}>
          {/* Breadcrumb hidden for now - enable later */}
          {/* {!isDashboard && (
            <div className="mb-3 sm:mb-4">
              <Breadcrumbs />
            </div>
          )} */}

          <div
            className={
              isDashboard || isFeedPage || isCourseWatch
                ? isFeedPage ? 'h-full' : ''
                : 'bg-white rounded-2xl shadow-sm border border-gray-100 p-3 sm:p-4 lg:p-5'
            }
          >
            {children || <Outlet />}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default UserLayout;
